import { defineStore } from 'pinia';
import { useGroupsStore } from './useGroupsStore';
import { useTemplateStore } from './useTemplateStore';
import { useNotificationsStore } from './useNotificationsStore';
import { useVariableStore } from './useVariableStore';

export const useRefetchStore = defineStore({
	id: 'refetch',
	actions: {
		async refetchAll(): Promise<void> {
			const groupsStore = useGroupsStore();
			const templateStore = useTemplateStore();
			const notificationsStore = useNotificationsStore();
			const variableStore = useVariableStore();

			await Promise.all([
				groupsStore.fetchGroups(),
				templateStore.fetchTemplates(),
				notificationsStore.fetchNotificationsPerGroup(),
				notificationsStore.fetchTotalCountAndRate(),
				variableStore.fetchVariables(),
			]);
		},
	},
});
